import Page from './Page';

export const Home = () => (
  <Page title="Home">Welcome to the Galaxy. 🌘🛰⭐</Page>
);
